import useSubdomain from '../../hooks/use-subdomain';
import { EventSettingsContextType } from '../../context-providers/event-settings-context/event-settings-context';
import { PassportPageType } from '../api/custom-page.types';

/*eslint-disable*/
export const getEventNameFromUrl = (isDomain = true): string | null => {
  const url = window.location.href;
  return isDomain ? useSubdomain(url) : _getEventNameAsPath(url);
};
/*eslint-enable*/

const _getEventNameAsPath = (url: string): string | null => {
  const match = url.match(/^http:\/\/([^.]+)\.(?:[a-zA-Z].com|localhost:3000)\/([^/]+)\//);

  if (match) {
    const domain = match[1]; // For now we are catching only the domain as the event name
    return domain;
  } else {
    return null;
  }
};

export const normalizeRoutePath = (path: string, pathPrefix?: string): string => {
  let _path = path.startsWith('/') || !path ? path : `/${path}`;
  /* remove trailing slash from the root path when prefix provided */
  if (_path === '/' && pathPrefix) {
    _path = '';
  }

  return pathPrefix ? `/${pathPrefix}${_path}` : _path;
};

const isBookAMeetingPageEnabled = (
  enabled: boolean,
  publicEnabled: boolean,
  isAuthenticated: boolean
): boolean => (isAuthenticated ? enabled : publicEnabled);

/**
 * Gets all enabled Book a Meeting page paths for the current auth state.
 */
export const getBookAMeetingPaths = (
  eventSettings: EventSettingsContextType,
  pathPrefix: string,
  isAuthenticated: boolean
): string[] => {
  if (!eventSettings.customPages?.length) {
    return [];
  }

  return eventSettings.customPages
    .filter(
      page =>
        page.type === PassportPageType.BOOK_A_MEETING &&
        isBookAMeetingPageEnabled(page.enabled, page.publicEnabled, isAuthenticated)
    )
    .map(page =>
      normalizeRoutePath(`/${page.path || 'book-a-meeting'}`, pathPrefix)
    );
};

/**
 * Returns true when the given path matches any enabled Book a Meeting page.
 */
export const isBookAMeetingPath = (
  path: string,
  eventSettings: EventSettingsContextType,
  pathPrefix: string,
  isAuthenticated: boolean
): boolean => getBookAMeetingPaths(eventSettings, pathPrefix, isAuthenticated).includes(path);

/**
 * Gets the first Book a Meeting page path if one exists and is enabled.
 * Prefer preserving the exact current pathname for back navigation when multiple pages exist.
 */
export const getBookAMeetingPath = (
  eventSettings: EventSettingsContextType,
  pathPrefix: string,
  isAuthenticated: boolean
): string | null => {
  const paths = getBookAMeetingPaths(eventSettings, pathPrefix, isAuthenticated);
  return paths.length > 0 ? paths[0] : null;
};

export const getFirstPathSegmentFromLocation = (): string => {
  return window.location.pathname.split('/')[1];
};

export const getPathSegmentListFromLocation = (): string[] => {
  return window.location.pathname.split('/').filter(Boolean);
};